import React from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw, ArrowUpRight, ArrowDownLeft } from 'lucide-react';
import { Badge } from '../ui/badge';

const KIND = {
  top_up: { cls: 'bg-sky-100 text-sky-800 hover:bg-sky-100', Icon: ArrowUpRight, key: 'mileage.topUp' },
  refund: { cls: 'bg-rose-100 text-rose-800 hover:bg-rose-100', Icon: ArrowDownLeft, key: 'mileage.refund' },
};

/** Mileage expense badges: "needs update" while its sheet is reopened, top-up/refund for post-payout corrections. */
export const MileageUpdateBadge = ({ expense }) => {
  const { t } = useTranslation();
  const kind = KIND[expense?.mileage_adjustment_kind];
  if (kind) {
    const { cls, Icon, key } = kind;
    return (
      <Badge className={`${cls} text-[10px] px-1.5 whitespace-nowrap`} title={t('mileage.adjustmentHint')} data-testid={`mileage-adjustment-${expense.id}`}>
        <Icon className="h-3 w-3 mr-1" />{t(key)}
      </Badge>
    );
  }
  if (!expense?.mileage_needs_update) return null;
  return (
    <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100 text-[10px] px-1.5 whitespace-nowrap" title={t('mileage.needsUpdateHint')}
      data-testid={`mileage-needs-update-${expense.id}`}>
      <RefreshCw className="h-3 w-3 mr-1" />{t('mileage.needsUpdate')}
    </Badge>
  );
};

export default MileageUpdateBadge;
